<head-page class="noprint"></head-page>
<div class="full-container mt-90">
  <router-outlet></router-outlet>
  <overlay-loading
    *ngIf="(loadingService.loading$ | async) && !loadingService.isHome"
  ></overlay-loading>
</div>
<app-workflow-assistant *ngIf="showWorkflowAssistant"></app-workflow-assistant>
